import { render, staticRenderFns } from "./LotsTraceability.vue?vue&type=template&id=07ad2136&scoped=true"
import script from "./LotsTraceability.vue?vue&type=script&lang=js"
export * from "./LotsTraceability.vue?vue&type=script&lang=js"
import style0 from "./LotsTraceability.vue?vue&type=style&index=0&id=07ad2136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ad2136",
  null
  
)

export default component.exports